import { mean, round } from 'lodash'

export interface IQuestion {
  id: string
  text: string
  description: string
}

export const parseQuestions = (questions: string[]): IQuestion[] => {
  return questions.map((question) => JSON.parse(question))
}

export const calculateAverageRating = (scores: Array<number | undefined | null>) => {
  const filteredZeros = scores.filter((score) => score !== 0)
  const rounded = round(mean(filteredZeros))

  return rounded || null
}
